<template>
  <div class="dashboard">


    <div class="row">
        <div class="flex xs12 sm12 lg12">
          <va-card >
           <p  style="font-size: 25px"> {{$t('dashboard.SistemaGestao')}}</p>
                    <hr>
          </va-card>
        </div>
    </div>

     <div class="row">
      
        <div class="flex xs12 sm12 lg3">
          <va-card title="Pressed Button Gradients">
                <va-button v-on:click="currentTab = videos.componet" :color="videos.color" :style="videos" > {{ $t('gestaoconteudo.Videos') }}</va-button>
                <va-button v-on:click="currentTab = slides.componet" :color="slides.color" :style="slides" > {{ $t('gestaoconteudo.Slides') }}</va-button>
                <va-button v-on:click="currentTab = audios.componet" :color="audios.color" :style="audios" > {{ $t('gestaoconteudo.Audios') }}</va-button>
                <va-button v-on:click="currentTab = questionarios.componet" :color="questionarios.color" :style="questionarios" > {{ $t('gestaoconteudo.Questionarios') }}</va-button>
                <va-button v-on:click="currentTab = extras.componet" :color="extras.color" :style="extras" > {{ $t('gestaoconteudo.Extras') }}</va-button>
                <va-button v-on:click="currentTab = perguntas.componet" :color="perguntas.color" :style="perguntas" > Perguntas </va-button>
                <va-button v-on:click="currentTab = programa.componet" :color="programa.color" :style="programa" > Programa academico </va-button>
                <!-- <va-button v-on:click="currentTab = avaliacoes.componet" :color="avaliacoes.color" :style="avaliacoes" > {{ $t('gestaoconteudo.Avaliacoes') }}</va-button> -->
          </va-card>
        </div>

        <div class="flex xs12 sm12 lg9">
          <va-card >
         
          <component 
          v-on:trocar_component="trocar_component"
          v-bind:is="currentTabComponent
          "></component>
          </va-card>
        </div>
    </div>

  </div>
</template>

<script>
import videos from './Videos'
import slides from './Slides'
import audios from './Audios'
import questionarios from './Questionarios'
import extras from './Extras'
import perguntas from './Perguntas'
import programa from './Programa'

export default {
  name: 'dashboard',
  components: {
   videos,
   slides,
   audios,
   questionarios,
   extras,
   perguntas,
   programa

  },

  data () {
      return {
        videos: {
          componet: 'videos',
          color:'success',
          'width': '100%',
        }, 
        slides: {
           componet: 'slides',
          color:'success',
          'width': '100%',
        }, 
        audios: {
          componet: 'audios',
          color:'success',
          'width': '100%',
        }, 
        questionarios: {
          componet: 'questionarios',
          color:'success',
          'width': '100%',
        }, 
        extras: {
          componet: 'extras',
          color:'success',
          'min-width': '100%',
        }, 
        perguntas: {
          componet: 'perguntas',
          color:'success',
          'min-width': '100%',
        }, 
        programa: {
          componet: 'programa',
          color:'success',
          'min-width': '100%',
        }, 

      currentTab: 'videos',
     
      }
    },

  computed: {
    currentTabComponent () {
      console.log(this.currentTab)
      return  this.currentTab.toLowerCase()

    }
  },

  methods: {

    trocar_component (value) {
    //  alert(value)
      this.currentTab = value
      
    }
    
 
  },
}
</script>

<style lang="scss">
  .row-equal .flex {
    .va-card {
      height: 100%;
    }
  }
  .dashboard {
    .va-card {
      margin-bottom: 0 !important;
    }
  }
</style>
